<template>
  <div>
    <z-button
      v-if="isMobile"
      variant="secondary"
      class="index-card__button"
      @click="setBottomSheetOpen(true)"
    >
      <z-icon
        size="medium"
        :icon="['fal', 'list-ol']"
        class="index-card__button__icon"
      />
      {{ indexText }}
    </z-button>

    <z-card v-if="!isMobile">
      <z-title
        tag="h2"
        size="small"
        class="index-card__title"
      >
        {{ indexText }}
      </z-title>

      <IndexSummary
        :summary="summary"
        :set-bottom-sheet-open="setBottomSheetOpen"
      />
    </z-card>

    <z-modal
      :open="isBottomSheetOpen"
      class="index-card__modal"
      closable
      size="auto"
      @closed="setBottomSheetOpen(false)"
    >
      <div class="index-card__content lesson__section-content">
        <z-title
          tag="h2"
          size="small"
          class="index-card__title"
        >
          {{ indexText }}
        </z-title>

        <IndexSummary
          :summary="summary"
          :set-bottom-sheet-open="setBottomSheetOpen"
        />
      </div>
    </z-modal>
  </div>
</template>

<script>
import { ZCard } from '@quero/zilla-vue'
import IndexSummary from './summary.vue'

export default {
  name: 'IndexCard',
  components: {
    ZCard,
    IndexSummary,
  },
  props: {
    summary: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      isMobile: false,
      isBottomSheetOpen: false,
      indexText: 'Índice',
    }
  },
  beforeMount () {
    this.isMobile = window.matchMedia('(max-width: 768px)').matches
  },
  methods: {
    setBottomSheetOpen (value) {
      this.isBottomSheetOpen = value
    },
  },
}
</script>

<style lang="scss">
.index-card__button {
  align-items: center;
  background-color: var(--color-blue-000);
  display: flex;
  flex-direction: row;
  width: 100%;
  border-radius: var(--unit-0200);
}

.index-card__button__icon {
  margin-right: var(--unit-0200);
}

.index-card__title {
  margin: 0 0 var(--unit-0300);
}

.z-modal__wrapper {
  background-color: var(--color-white);
}

.z-modal__dialog {
  padding-top: 0;
}

.z-modal__wrapper > .z-modal__close-button {
  margin-top: var(--unit-0200);
  margin-right: var(--unit-0200);
  color: var(--color-black);
}
</style>
